import React, {Component} from 'react';
import PermissionsView from "./PermissionsView";
import {Growl} from "primereact/growl";
import {MaintenanceUsersService} from "../../../../service/maintenance/users/MaintenanceUsersService";
import {MAINTENANCE_USERS_ROUTE} from "../../../../utils/constants/RoutesConstants";
import {Button} from "primereact/button";
import SubtitleLabel from "../../../../app/Title/SubtitleLabel/SubtitleLabelView";


export default class PermissionsContainer extends Component {
    /**
     * Constructor de la clase, se inicializan las variables.
     * Se toma el elemento a editar que viene de la pantalla anterior.
     * @param {jmap} props Argumento que trae los valores iniciales de la clase
     *              Trae el elemento de la pantalla anterior para editar.
     */
    constructor(props) {
        super(props);
        this.maintenanceUsersService = new MaintenanceUsersService();

        this.state = {
            returnPath: this.props.location.state.returnPath,
            user: this.props.location.state.selectedUser,
            sourceProcess: [],
            targetProcess: [],
            userObj: '',
            usersList: [],
            isLoading: false,
        };

        this.returnUpdateUsersPage = this.returnUpdateUsersPage.bind(this);
        this.processTemplate = this.processTemplate.bind(this);
        this.onChangePickList = this.onChangePickList.bind(this);
        this.onHideDialog = this.onHideDialog.bind(this);
        this.openCopyDialog = this.openCopyDialog.bind(this);
        this.assignProcesses = this.assignProcesses.bind(this);
        this.copyUserProcesses = this.copyUserProcesses.bind(this);
        this.onChangeDropDown = this.onChangeDropDown.bind(this);
        this.loading = this.loading.bind(this);

    }

    componentDidMount() {
        this.maintenanceUsersService.getDataProcess(this.props.location.state.selectedUser)
            .then(res => {
                this.setState({
                    targetProcess: res[0],
                    sourceProcess: res[1],
                });
            });
    }

    processTemplate(process) {
        return (
            <div className="p-clearfix">
                <SubtitleLabel header={process.detalle} isBold={true}/>
            </div>
        );
    }

    onChangePickList(event) {
        this.setState({
            sourceProcess: event.source,
            targetProcess: event.target
        });
    }

    onChangeDropDown(event) {
        let {name, value} = event.target;
        this.setState({[name]: value,})
    }

    assignProcesses() {
        this.loading(true);
        let targetProcessAux = this.state.targetProcess;
        let processListStr = "";
        targetProcessAux.forEach(item => {
            processListStr = processListStr.concat("," + item.idObjetoProceso);
        });
        this.maintenanceUsersService.assignProcess(this.state.user.usuario, processListStr)
            .then(res => {
                if (res.message === "Success") {
                    let message = {};
                    message['severity'] = 'success';
                    message['summary'] = 'Éxito.';
                    message['detail'] = 'Las pantallas se asignaron correctamente';
                    this.returnUpdateUsersPage(message);
                } else {
                    this.growl.show({
                        severity: 'error', summary: 'Error.',
                        detail: res.error
                    });
                }
            });
        this.loading(false);
    }

    /**
     * Función que setea la variable para que se vea la barra de carga
     */
    loading(option) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: option ? option : false,
            });
        }
    }

    onHideDialog() {
        this.setState({displayDialog: false});
    }

    openCopyDialog() {
        this.loading(true);
        this.maintenanceUsersService.getDataUsers('',
            this.state.user.idInstitucion)
            .then(res => {
                let userSelected = this.state.user.usuario;
                let userList = res.filter(elem =>
                    elem.usuario !== userSelected);
                this.setState({
                    userObj: '',
                    usersList: userList,
                    displayDialog: true,
                });
            });
        this.loading(false);
    }

    copyUserProcesses() {
        this.loading(true);
        if (this.state.userObj !== '') {
            this.maintenanceUsersService.copyUserProcesses(
                this.state.user.usuario, this.state.userObj.usuario)
                .then(res => {
                    if (res.message === "Success") {
                        this.onHideDialog();
                        let message = {};
                        message['severity'] = 'success';
                        message['summary'] = 'Éxito.';
                        message['detail'] = 'Las pantallas se asignaron correctamente';
                        this.returnUpdateUsersPage(message);
                    } else {
                        this.growl.show({
                            severity: 'error', summary: 'Error.',
                            detail: res.error
                        });
                    }
                });
        } else {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: "Seleccione un usuario"
            });
        }
        this.loading(false)
    }


    /**
     * Función que regresa a la pantalla de Captura de Garantías
     */
    returnUpdateUsersPage(message) {
        this.setState({isLoading: false,});
        this.props.history.push({
            pathname: this.state.returnPath,
            message: message,
            state: {
                returnPath: MAINTENANCE_USERS_ROUTE,
                newUser: false,
                selectedUser: this.state.user,
            },
        });
    }

    /**
     * Función que realiza el render de la pantalla cuando existe un cambio.
     * En esta se le pasa a la vista lo que necesita para pintarse.
     * @returns {*}
     */
    render() {
        let dialogHeader =
            <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-6 p-lg-8">
                    <h2 className={"secondary-text"}>Copiar permisos desde</h2>
                </div>
                <div className="p-col-12 p-md-3 p-lg-2">
                    <Button label="Regresar" onClick={this.onHideDialog}
                            className="p-button-secondary"/>
                </div>
                <div className="p-col-12 p-md-3 p-lg-2">
                    <Button label="Copiar" onClick={this.copyUserProcesses}/>
                </div>
            </div>;
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        const {
            user, sourceProcess, isLoading, targetProcess, displayDialog,
            usersList, userObj
        } = this.state;

        return (
            <PermissionsView
                user={user}
                sourceProcess={sourceProcess}
                messagesGrowl={messagesGrowl}
                isLoading={isLoading}
                targetProcess={targetProcess}
                dialogHeader={dialogHeader}
                displayDialog={displayDialog}
                usersList={usersList}
                userObj={userObj}
                processTemplate={this.processTemplate}
                onChangePickList={this.onChangePickList}
                assignProcesses={this.assignProcesses}
                onHideDialog={this.onHideDialog}
                openCopyDialog={this.openCopyDialog}
                onChangeDropDown={this.onChangeDropDown}
                loading={this.loading}
                returnUpdateUsersPage={this.returnUpdateUsersPage}
            />
        );
    }
}
